import CertificationList from './CertificationList';

export default CertificationList;
